import React, { Fragment } from 'react'
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import { useDispatch, useSelector } from 'react-redux'
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { actualizarDatosFilesCliente, obtenerClienteConDetalle } from '../../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';


function BotonDocumentoValidoComponent(props) {

    const dispatch = useDispatch()
    const [documentoValido, setDocumentoValido] = React.useState(props.data.isDocumentoValido)
    const [fechaInicio, setFechaInicio] = React.useState(props.data.fechaInicio == '---' ? '' : props.data.fechaInicio)
    const [fechaTermino, setFechaTermino] = React.useState(props.data.fechaTermino == '---' ? '' : props.data.fechaTermino)

    let tooltipMsj = props.data.isDocumentoValido == true ? 'Documento inválido.' : 'Documento correcto.'

    const theme = createTheme({
        components: {
            MuiSwitch: {
                styleOverrides: {
                    switchBase: {
                        color: "#8ABE3E"
                    },
                    colorPrimary: {
                        "&.Mui-checked": {
                            color: "#DC3545"
                        }
                    },
                    track: {
                        opacity: 0.4,
                        backgroundColor: "#8ABE3E",
                        ".Mui-checked.Mui-checked + &": {
                            opacity: 0.4,
                            backgroundColor: "#DC3545"
                        }
                    }
                }
            }
        }
    });

    const guardarDocumentoValido = async (isDocValido) => {
        let data = {}
        let fechaI = null
        let fechaF = null

        if (fechaInicio != '') {
            fechaI = new Date(fechaInicio).toISOString()
        }

        if (fechaTermino != '') {
            fechaF = new Date(fechaTermino).toISOString()
        }

        if (props?.data?.tabla == 'archivosgeneralescliente') {
            data = {
                id: props?.data?.idSolicitud, nombreid: 'idarchivosgeneralescliente', tabla: props?.data?.tabla,
                fechainicio: fechaI, fechafin: fechaF, observaciones: props?.data?.observacion,
                estatus: props?.data?.estatus, isdocumentovalido: isDocValido
            }
        }
        if (props?.data?.tabla == 'archivosapoderadoslegalescliente') {
            data = {
                id: props?.data?.idAnexo, nombreid: 'idarchivosapoderadoscliente', tabla: props?.data?.tabla,
                fechainicio: fechaI, fechafin: fechaF, observaciones: props?.data?.observacion,
                estatus: props?.data?.estatus, isdocumentovalido: isDocValido
            }
        }
        if (props?.data?.tabla == 'archivospersonasautorizadascliente') {
            data = {
                id: props?.data?.idAnexo, nombreid: 'idarchivospersonasatutorizadascliente', tabla: props?.data?.tabla,
                fechainicio: fechaI, fechafin: fechaF, observaciones: props?.data?.observacion,
                estatus: props?.data?.estatus, isdocumentovalido: isDocValido
            }
        }
        if (props?.data?.tabla == 'archivospredioscliente') {
            data = {
                id: props?.data?.idAnexo, nombreid: 'idarchivospredio', tabla: props?.data?.tabla,
                fechainicio: fechaI, fechafin: fechaF, observaciones: props?.data?.observacion,
                estatus: props?.data?.estatus, isdocumentovalido: isDocValido
            }
        }
        if (props?.data?.tabla == 'archivosviveroscliente') {
            data = {
                id: props?.data?.idAnexo, nombreid: 'idarchivosvivero', tabla: props?.data?.tabla,
                fechainicio: fechaI, fechafin: fechaF, observaciones: props?.data?.observacion,
                estatus: props?.data?.estatus, isdocumentovalido: isDocValido
            }
        }
        if (props?.data?.tabla == 'archivosinstalacionescliente') {
            data = {
                id: props?.data?.idAnexo, nombreid: 'idarchivosinstalacion', tabla: props?.data?.tabla,
                fechainicio: fechaI, fechafin: fechaF, observaciones: props?.data?.observacion,
                estatus: props?.data?.estatus, isdocumentovalido: isDocValido
            }
        }
        if (props?.data?.tabla == 'archivosresposansablescliente') {
            data = {
                id: props?.data?.idAnexo, nombreid: 'idarchivosresponsables', tabla: props?.data?.tabla,
                fechainicio: fechaI, fechafin: fechaF, observaciones: props?.data?.observacion,
                estatus: props?.data?.estatus, isdocumentovalido: isDocValido
            }
        }
        if (props?.data?.tabla == 'archivosmarcascliente') {
            data = {
                id: props?.data?.idAnexo, nombreid: 'idarchivosmarca', tabla: props?.data?.tabla,
                fechainicio: fechaI, fechafin: fechaF, observaciones: props?.data?.observacion,
                estatus: props?.data?.estatus, isdocumentovalido: isDocValido
            }
        }
        if (props?.data?.tabla == 'archivosmarcasproductocliente') {
            data = {
                id: props?.data?.idAnexo, nombreid: 'idarchivosmarcaproducto', tabla: props?.data?.tabla,
                fechainicio: fechaI, fechafin: fechaF, observaciones: props?.data?.observacion,
                estatus: props?.data?.estatus, isdocumentovalido: isDocValido
            }
        }

        await dispatch(actualizarDatosFilesCliente(data))
        await dispatch(obtenerClienteConDetalle(props?.idcliente))
    }

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <Tooltip title={tooltipMsj}>
                    <Switch
                        checked={documentoValido}
                        onChange={e => setDocumentoValido(e.target.checked)}
                        onClick={e => guardarDocumentoValido(e.target.checked)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                </Tooltip>
            </ThemeProvider>
        </Fragment>
    )
}

export default BotonDocumentoValidoComponent